import type { ShiftNote, ShiftNoteCategory } from '@/api/shiftDashboardApi'

// ─── Shift notes (z8nrz7fbcq) ────────────────────────────────────────────────
// Pure, so the rules are unit-tested (vitest here runs `.ts` only).

/** Same cap as the server's DTO. */
export const NOTE_MAX_LENGTH = 2000

export const NOTE_CATEGORIES: { id: ShiftNoteCategory; label: string }[] = [
  { id: 'safety', label: 'Safety' },
  { id: 'lab', label: 'Lab' },
  { id: 'equipment', label: 'Equipment' },
  { id: 'staffing', label: 'Staffing' },
  { id: 'general', label: 'General' },
]

export function noteCategoryLabel(id: string): string {
  return NOTE_CATEGORIES.find((c) => c.id === id)?.label ?? 'General'
}

/**
 * Open notes before resolved ones, open safety notes first of all, newest
 * first within each — a handover reads the unresolved hazards before anything.
 */
export function sortNotes(notes: ShiftNote[]): ShiftNote[] {
  const rank = (n: ShiftNote) => (n.resolved ? 2 : n.category === 'safety' ? 0 : 1)
  return [...notes].sort((a, b) => rank(a) - rank(b) || b.createdAt.localeCompare(a.createdAt))
}
